import React from "react";
import { FiHeadphones, FiPackage, FiRefreshCcw, FiTruck } from "react-icons/fi";
import siteConfig, { formatCurrency } from "../../config/siteConfig";

const items = [
  {
    icon: FiTruck,
    title: "Flat-rate shipping",
    text: `${formatCurrency(siteConfig.shipping.standardRate)} to supported destinations`,
  },
  { icon: FiRefreshCcw, title: "Cook with confidence", text: "30-day pantry promise" },
  { icon: FiPackage, title: "Packed fresh", text: "Ground and blended in small lots" },
  { icon: FiHeadphones, title: "Real spice people", text: "Friendly help, Monday–Friday" },
];

const TrustStrip = () => (
  <section className="trust-strip" aria-label="Store benefits">
    <div className="site-container trust-strip__grid">
      {items.map(({ icon: Icon, title, text }) => (
        <div className="trust-strip__item" key={title}>
          <Icon aria-hidden="true" />
          <div>
            <strong>{title}</strong>
            <span>{text}</span>
          </div>
        </div>
      ))}
    </div>
  </section>
);

export default TrustStrip;
